import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export default function StepperRail({ steps, step, onStepClick }) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {steps.map((s, i) => {
        const active = i === step;
        const completed = i < step;

        return (
          <Box
            key={s.key}
            onClick={() => onStepClick?.(i)}
            sx={{
              minWidth: { xs: "calc(50% - 4px)", md: 150 },
              flex: { xs: "1 1 calc(50% - 4px)", md: "0 1 auto" },
              cursor: "pointer",
              borderRadius: 2,
              px: 1.25,
              py: 1.1,
              border: active
                ? "1px solid rgba(0,225,255,0.35)"
                : completed
                  ? "1px solid rgba(109,255,178,0.2)"
                  : "1px solid rgba(255,255,255,0.08)",
              bgcolor: active
                ? "rgba(0,225,255,0.08)"
                : completed
                  ? "rgba(109,255,178,0.07)"
                  : "rgba(255,255,255,0.03)",
              transition: "all 0.22s ease",
              "&:hover": {
                transform: "translateY(-1px)",
                borderColor: active
                  ? "rgba(0,225,255,0.45)"
                  : "rgba(255,255,255,0.18)",
                bgcolor: active
                  ? "rgba(0,225,255,0.1)"
                  : "rgba(255,255,255,0.05)",
              },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                size="small"
                label={
                  completed ? <CheckRoundedIcon sx={{ fontSize: 16 }} /> : i + 1
                }
                sx={{
                  width: 28,
                  height: 28,
                  fontWeight: 900,
                  bgcolor: active
                    ? "rgba(0,225,255,0.18)"
                    : completed
                      ? "rgba(109,255,178,0.18)"
                      : "rgba(255,255,255,0.08)",
                  color: active
                    ? "#8ef4ff"
                    : completed
                      ? "#9dffc8"
                      : "rgba(255,255,255,0.8)",
                  borderRadius: 2,
                  "& .MuiChip-label": { px: 0.8 },
                }}
              />
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: active ? 900 : 700,
                  color: active
                    ? "#fff"
                    : completed
                      ? "rgba(255,255,255,0.88)"
                      : "rgba(255,255,255,0.62)",
                  lineHeight: 1.2,
                }}
              >
                {s.label}
              </Typography>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
